
import { defineComponent, computed, ref, onMounted, onBeforeUnmount } from 'vue';

export default defineComponent({
  name: 'UpdateTime',
  props: {
    updated: Number
  },
  setup(props) {
    // 每 10s 触发一次重算，保证"x 分钟前"随时间流逝更新
    const now = ref<number>(Date.now() / 1000);
    let timer: number;
    onMounted(() => (timer = setInterval(() => (now.value = Date.now() / 1000), 10000)));
    onBeforeUnmount(() => clearInterval(timer));

    const elapsed = computed((): number | undefined =>
      props.updated ? Math.max(0, Math.floor(now.value - props.updated)) : undefined
    );

    const timeSince = computed((): string => {
      const seconds = elapsed.value;
      if (seconds === undefined) return '从未';
      let interval = Math.floor(seconds / 31536000);
      if (interval >= 1) return `${interval} 年前`;
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) return `${interval} 月前`;
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) return `${interval} 天前`;
      interval = Math.floor(seconds / 3600);
      if (interval >= 1) return `${interval} 小时前`;
      interval = Math.floor(seconds / 60);
      if (interval >= 1) return `${interval} 分钟前`;
      return '几秒前';
    });

    // 数据新鲜度：绿 = 正常刷新；黄 = 数秒~1 小时未更新；红 = 更久或从未
    const freshness = computed((): string => {
      const seconds = elapsed.value;
      const { interval } = window.__PRE_CONFIG__;
      if (seconds === undefined) return 'dead';
      if (seconds <= Math.max(interval * 5, 30)) return '';
      if (seconds <= 3600) return 'stale';
      return 'dead';
    });

    const absoluteTime = computed((): string =>
      props.updated ? new Date(props.updated * 1000).toLocaleString() : ''
    );

    return {
      timeSince,
      freshness,
      absoluteTime
    };
  }
});
